import React from 'react';
import './user info.css'
import { MDBContainer,  MDBRow, MDBCol,MDBBtn,MDBIcon,MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
//import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message,TreeSelect,Image,Spin,Empty,DatePicker } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import Rater from "react-rater";
import "react-rater/lib/react-rater.css";
import Skeleton from 'react-loading-skeleton';
import Pagination from '@material-ui/lab/Pagination';
import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment';
//import crypto from "crypto"
import CryptoJS from 'crypto-js'
import {setUser} from '../../redux/actions/AuthActions'

const { TreeNode } = TreeSelect;
async function decryptedData(encryptedData,securitykey) {
    let iv = 'mcgw2K5uCV5$%x&n';
    var decryptedData = CryptoJS.AES.decrypt(encryptedData, CryptoJS.enc.Utf8.parse(securitykey), 
    {iv: CryptoJS.enc.Utf8.parse(iv),mode: CryptoJS.mode.CBC,format: CryptoJS.format.Hex })
    .toString(CryptoJS.enc.Utf8);
    console.log("decryptedData",decryptedData); 
    return decryptedData;
}
class UserInfo extends React.Component {
    state = {
        actionType:this.props.location.state.actionType?this.props.location.state.actionType==="EDIT"?"EDIT":"VIEW":"VIEW",
        id:this.props.location.state.data.id,
        user: this.props.location.state?this.props.location.state.data:[],
        
        fullname: this.props.location.state.data.fullname?this.props.location.state.data.fullname:"",
        username: this.props.location.state.data.username?this.props.location.state.data.username:"",

        birthday: this.props.location.state.data.birthday?this.props.location.state.data.birthday:'2021-12-01',
        email:this.props.location.state.data.email?this.props.location.state.data.email:"",
        type:this.props.location.state.data.type?this.props.location.state.data.type:"",
        phone:this.props.location.state.data.phone?this.props.location.state.data.phone:"",
        accountType:this.props.location.state.data.accountType?this.props.location.state.data.accountType:"",
        modal:false,
        blockReason:"",
        reason:"",
        gender:null,
        img:this.props.location.state?this.props.location.state.data.img !== ""?this.props.location.state.data.img:null:null,
        country:[],
        countryCode:'',
        occasions:0,
        myContacts:0,
        fileType:"data",
        filePreviewName:[],
        countries:[],
        selectedFile: null,
        loading:true,
        refresh:false,
        page:1,
        pages:1,
        imgType:'url',
        imgName:'',
        permissions:[],
        permission:null,
        contacts:[],
        giftsCount:0,
        lastDevice:[],
        userSecretkey:''
    };
      
    constructor(props){
      super(props)
      window.scrollTo(0,0)
      this.getUserData()
      this.getLastDevice()
      this.getPermissions()
      this.fileChangedHandler = this.fileChangedHandler.bind(this);
      this.getcountries()
      if(this.props.isRTL){
        allStrings.setLanguage('ar')
      }else{
        allStrings.setLanguage('en')
      } 
    }
    
    getContacts = (page,startSecretkey) => {
      axios.get(`${BASE_END_POINT}${this.props.location.state.data.id}/getContacts?page=${page}&limit=10`,
      {
          headers:{
            'Authorization':`Bearer ${this.props.currentUser.token}`,
            'Accept-Language':this.props.isRTL?'ar':'en'
          }
      })
      .then(async(response)=>{
          console.log('contacts  ',response.data)
          let contacts = response.data.data
          let theContacts = []
          if(this.props.currentUser.user.type ==="ADMIN"){
            for (let i = 0; i < contacts.length; i++) {
              let theItem = contacts[i];
              let secretkey = startSecretkey + "ZWGcON/5fIQb.U/2";
              console.log("secretkey",secretkey)
              let decryptedPhone = await decryptedData(theItem.phone,secretkey)
              console.log("decryptedPhone",decryptedPhone)
              theContacts.push({
                phone:decryptedPhone,
                name:theItem.name,
                id:theItem.id
              })
              
            }
          }else{
            theContacts = response.data.data
          }
          
          this.setState({
            contacts:theContacts,
            pages:response.data.pageCount,
            page:response.data.page,
            loading:false,
          })
      })
      .catch(error=>{
          console.log('contacts ERROR  ',error)
          console.log('contacts ERROR  ',error.respose)
      })
    }
    getUserData = () => {
      axios.get(`${BASE_END_POINT}${this.state.id}/findById`,{
        headers: {
        'Content-Type': 'application/json',
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
        }})
      .then(response=>{
        console.log('theUser   ',response.data)
          this.setState({
            permission:response.data.user.permission?response.data.user.permission.id:null,
            loading:false,
            blockReason:response.data.user.blockReason?response.data.user.blockReason:"",
            occasions:response.data.user.occasions?response.data.user.occasions:0,
            giftsCount:response.data.user.gifts?response.data.user.gifts:0,
            myContacts:response.data.user.myContacts?response.data.user.myContacts:0,
            phone:response.data.user.phone?response.data.user.phone:"",
            email:response.data.user.email?response.data.user.email:"",
            birthday:response.data.user.birthday?response.data.user.birthday:'2021-12-01',
            fullname:response.data.user.fullname?response.data.user.fullname:"",
            username:response.data.user.username?response.data.user.username:"",
            accountType:response.data.user.accountType?response.data.user.accountType:"",
            gender:response.data.user.gender?response.data.user.gender:null,
            type:response.data.user.type?response.data.user.type:"",
            city:response.data.user.city?response.data.user.city.id:null,
            country:response.data.user.country?response.data.user.country.id:null,
            img:response.data.user.img?response.data.user.img:null,
            userSecretKey:response.data.user.userSecretKey?response.data.user.userSecretKey:"",
           })
          if(this.state.type ==="USER"){
            this.getContacts(1,response.data.user.userSecretKey)
          }
          this.getCountry(response.data.user.country?response.data.user.country.id:0)
      })
      .catch(error=>{
          console.log('theUser ERROR  ',error)
          console.log('theUser ERROR  ',error.respose)
      })
    }
    /**
     * get permissions request
    */
    getPermissions = () => {
      axios.get(`${BASE_END_POINT}permission/withoutPagenation/get`)
      .then(response=>{
        console.log(response.data)
        this.setState({permissions:response.data.data,loading:false})
      })
      .catch(error=>{
        console.log("ALL permissions ERROR")
        console.log(error.response)
      })
    }
    getLastDevice = () => {
      axios.get(`${BASE_END_POINT}getAllDevices?user=${this.state.id}&limit=1`,{
        headers: {
        'Content-Type': 'application/json',
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
        }})
      .then(response=>{
        console.log(response.data)
        this.setState({lastDevice:response.data.data,loading:false})
      })
      .catch(error=>{
        console.log("lastDevice ERROR")
        console.log(error.response)
      })
    }
    
    getCountry = (id) => {
      axios.get(`${BASE_END_POINT}countries/${id}`)
      .then(response=>{
        this.setState({
          countryCode:response.data.data.countryCode,
          phone:this.state.phone.replace(response.data.data.countryCode, "")
        })
      })
      .catch(error=>{
        console.log(" country ERROR")
        console.log(error.response)
      })
    }
    componentDidMount(){
      this.getLastDevice()

      if(this.props.isRTL){
        allStrings.setLanguage('ar')
      }else{
        allStrings.setLanguage('en')
      }
    }
    getcountries = () => {
      axios.get(`${BASE_END_POINT}countries/withoutPagenation/get`)
      .then(response=>{
        console.log(response.data)
        this.setState({countries:response.data.data})
      })
      .catch(error=>{
        console.log("ALL countries ERROR")
        console.log(error.response)
      })
    }
    update = () => {
        const {img,fullname,phone,email,password,country,countryCode,permission,
        birthday,gender,username} = this.state
        let l = message.loading('Wait..', 2.5)
        
        if(hasValue(fullname)&&hasValue(email) ){
            
            console.log(countryCode)
            var data = new FormData()
            data.append('fullname',fullname)
            data.append('username',username)
            data.append('type',this.state.user.type)
            data.append('email',email)
            
            if(password !== '' && password !== undefined){
              data.append('password',password)
            }
            if(gender !== ''){
              data.append('gender',gender)
            }
            if(birthday !== ''){
              data.append('birthday',birthday)
            }
            
            data.append('country',country)
           
            if(this.state.type ==="SUB-ADMIN"){
              data.append('permission',permission)
            }
            if(countryCode ==="+20"){
              data.append('phone',"+2"+phone)
            }else{
              data.append('phone',countryCode+phone)
            }
            
            data.append('img',img)
            
            //////
            
            console.log(Array.from(data))
            
            axios.post(`${BASE_END_POINT}user/${this.state.id}/updateInfo`,data,{
            headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization':`Bearer ${this.props.currentUser.token}`,
            'Accept-Language':this.props.isRTL?'ar':'en'
            },
            })
            .then(response=>{
            l.then(() => message.success(allStrings.done, 2.5) )
              if(this.props.currentUser.user.id === this.state.id){
                localStorage.setItem('@USERWASHTO7B',JSON.stringify(response.data))
                this.props.setUser(response.data)
              }
              this.props.history.goBack()
            })
            .catch(error=>{
                console.log(error.response)
                l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
            })
        }
    }
    submitHandler = event => {
      event.preventDefault();
      event.target.className += " was-validated";
      this.update()
    };
  
    changeHandler = event => {
      this.setState({ [event.target.name]: event.target.value });
    };

    
    fileChangedHandler = event => {
        
      this.setState({
        img: event.target.files[0],
        imgName: event.target.files[0].name,
        imgType:"data"
      })
     
      
    }
    removeFile = () => {
      this.setState({
          img:null,
          imgName:'',
          imgType:"url"
      });
    }
    
    imageSection = () =>{
        
        return(
          <MDBCol  xl ="4" lg = "5"  md="12" sm="12">
          <div className="infoCard">
              <div style={{width:"100%" ,padding:'10px'}}>
              <Image
                width="100%"
                placeholder={true}
                style={{borderRadius:'6px',width:"100%",height:'280px'}} 
                src={this.state.imgType==="data"?URL.createObjectURL(this.state.img):this.props.location.state.data.img}
              />
              
              </div>
          </div>
          
      </MDBCol>
        )
    }
    onChangeBirthday = (date, dateString)=>{ 
      console.log(date, dateString);
      this.setState({birthday:dateString})
    }
    buttonsSection = () =>{
      return(
        <div className="btnOption">
          <MDBRow>
            
            <MDBCol md="12">
            {this.state.block===false?
              <MDBBtn
              rounded
              color="warning"
              style={{ borderRadius: "2px" }}
              className="btn-block z-depth-1a"
              onClick={this.toggle} 
            >
              <MDBIcon icon="check-circle" className="mr-2" />
              {allStrings.block}
            </MDBBtn>

            :
              <MDBBtn
                rounded
                color="success"
                style={{ borderRadius: "2px" }}
                className="btn-block z-depth-1a"
                onClick={()=>{
                  this.block(false)
                }}
              >
                <MDBIcon icon="ban" className="mr-2" />
                {allStrings.unBlock}
              </MDBBtn>
            }
              
            </MDBCol>
          </MDBRow>
          
        </div>
      )
    }
    delete = () => {
      let l = message.loading('Wait..', 2.5)
      axios.delete(`${BASE_END_POINT}${this.state.id}/delete`,{
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      },
      })
      .then(response=>{
        console.log("USER DELETED")
        l.then(() => message.success(allStrings.done, 2.5) )
        this.props.history.goBack()
      })
      .catch(error=>{
          console.log(error.response)
          l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
      })
    }
    
      
    reActive = () => {
      let uri ='';
        uri = `${BASE_END_POINT}${this.state.id}/reActive`
      let l = message
      .loading('Wait..', 2.5)
      axios.put(uri,{phone:this.state.phone},{
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.props.currentUser.token}`,
          'Accept-Language':this.props.isRTL?'ar':'en'
        },
      })
      .then(response=>{
            l.then(() => message.success(allStrings.done, 2.5))
            this.setState({active:true})
            //this.props.history.goBack()
      })
      .catch(error=>{
        console.log('Error   ',error.response)
        l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
      })
    }
    block = (block) => {
      let uri ='';
      let data = {}
      if(block){
       uri = `${BASE_END_POINT}${this.state.id}/block`
       data={blockReason:this.state.reason}
      }else{
       uri = `${BASE_END_POINT}${this.state.id}/unblock`
      }
     let l = message
      .loading('Wait..', 2.5)
      axios.put(uri,data,{
       headers: {
         'Content-Type': 'application/json',
         'Authorization': `Bearer ${this.props.currentUser.token}`,
         'Accept-Language':this.props.isRTL?'ar':'en'
       },
     })
      .then(response=>{
           if(block){
               l.then(() => message.success(allStrings.done, 2.5))
               this.setState({accountType:"BLOCKED",blockReason:this.state.reason})
               this.toggle()
           }else{
              l.then(() => message.success(allStrings.done, 2.5))
              this.setState({accountType:"ACTIVE"})
           }
           //this.props.history.goBack()
      })
      .catch(error=>{
       console.log('Error   ',error.response)
       l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
      })
    }
    submitHandlerBlock = (event) => {
      event.preventDefault();
      event.target.className += " was-validated";
      this.block(true)
    };
    changeHandlerBlock = (event) => {
        console.log(event.target.value);
        this.setState({ [event.target.name]: event.target.value });
    };
    toggle = () => {
      console.log(this.state.modal)
      this.setState({
        modal: !this.state.modal,
      });
    }
    modal = () =>(
      <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
        <MDBModalHeader toggle={this.toggle} >{allStrings.completeData}</MDBModalHeader>
          <MDBModalBody>
            <MDBContainer>
              <MDBRow>
                <MDBCol md="12">
                  <form style={{paddingTop:'1rem'}}
                    className="needs-validation"
                    onSubmit={this.submitHandlerBlock}
                    noValidate
                  >
                    <div className="grey-text">
                      <MDBRow>
                        <MDBCol md="12">
                          <div className="md-form">
                            <label htmlFor="form92" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.reason}</label>
                            <input  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} type="text" id="form92" className="form-control" onChange={this.changeHandlerBlock} required validate  name="reason"/>
                          </div>
                        </MDBCol>
                      </MDBRow>
                    </div>
                    <br></br>
                    <br></br>
                    <div className="text-center">
                      <MDBBtn type="submit" style={{ background: '#117183' }} rounded className="btn-block z-depth-1a" >
                        <MDBIcon className="mr-2" />
                        {allStrings.block}
                      </MDBBtn>
                    </div>
                  </form>
                </MDBCol>
              </MDBRow>
            </MDBContainer>
        </MDBModalBody>
      </MDBModal>
    );
    contactsTable = () =>{
      return(
      <MDBRow>
          <MDBCol md="12">
              <div className="infoTable">
                  <div className="topInfoTable" style={{ background: '#117183' }}>
                      <h4>
                      <MDBIcon icon="address-book" /> {allStrings.contacts}
                      </h4>
                  </div>
                  <div className="tableDate">
                      <div className="table-responsive">
                          <table className="table table-striped">
                          <thead>
                            {this.props.isRTL?
                              <tr style={{textAlign:'center'}}>
                                  <th>{allStrings.phone}</th>
                                  <th>{allStrings.name}</th>
                                  <th scope="col">#</th>
                              </tr>
                                  :
                              <tr style={{textAlign:'center'}}>
                                  <th scope="col">#</th>
                                  <th>{allStrings.name}</th>
                                  <th>{allStrings.phone}</th>
                              </tr>
                            }
                                
                          </thead>
                          <tbody>
                          {this.state.loading?
                              <tr style={{height: '200px'}}>
                                  <th colSpan="6" className="noData">
                                  <Skeleton height={400}/> 
                                  </th>
                              </tr>
                              :
                              this.state.contacts.length > 0 ?
                              this.state.contacts.map(contact =>(
                                this.props.isRTL?
                                <tr style={{textAlign:'center'}}>
                                    <td >{contact.phone}</td>
                                    <td>{contact.name}</td>
                                    <td>{contact.id}</td>
                                </tr>
                                :
                                <tr style={{textAlign:'center'}}>
                                    <td>{contact.id}</td>
                                    <td>{contact.name}</td>
                                    <td >{contact.phone}</td>
                                </tr>
                                  ))
              
                                  :
                                  <tr style={{height: '200px'}}>
                                      <th colSpan="6" className="noData">
                                      <Empty description={allStrings.noData} style={{margin:'0rem'}}/>
                                      </th>
                                  </tr>
                              }
                          </tbody>
                          </table>
                          {this.state.contacts.length > 0 &&
                              <div style={{textAlign:'center',margin:'auto',marginTop:'3rem'}}>
                                  {this.paginationButtons()}
                              </div>
                          }
                      </div>
                  </div>
              </div>
            </MDBCol>
        </MDBRow>
      )
    }
    paginationButtons = () =>(
      <CardActions style={{display: 'inline-flex'}}>
          <Button 
          onClick={()=>{
            if(this.state.page!==1){
              this.getContacts(1,this.state.userSecretKey)
              this.setState({page:1})
            }
          }}
          className="pagenation" >{allStrings.first}</Button>
  
          <Button 
          onClick={()=>{
            if(this.state.page>1){
              this.getContacts(this.state.page-1,this.state.userSecretKey)
              this.setState({page:this.state.page-1})
            }
          }}
          className="pagenation">{allStrings.prev}</Button>
          
          <Pagination
          onChange={(event,page)=>{
          console.log("page   ",page)
          if(page!==this.state.page){
            this.getContacts(page,this.state.userSecretKey)
            this.setState({page:page})
          }
          
          }} 
          defaultPage={1} page={this.state.page} count={this.state.pages} style={{color:`${'#117183'} !important`}} />
          
          <Button 
          onClick={()=>{
            if(this.state.page<this.state.pages){
              this.getContacts(this.state.page+1,this.state.userSecretKey)
              this.setState({page:this.state.page+1})
            }
          }}
          className="pagenation">{allStrings.next}</Button>
  
          <Button 
            onClick={()=>{
            if(this.state.page!==this.state.pages){
              this.getContacts(this.state.pages,this.state.userSecretKey)
              this.setState({page:this.state.pages})
            }
          }}
          className="pagenation">{allStrings.last}</Button>
  
      </CardActions>
    )
  render(){
    console.log("contry",this.state.countryCode)
    console.log("img",this.state.img)
  return (
    <div className="App">
     
      <Spin spinning={this.state.loading} tip={allStrings.loading} size="large" style={{color:'#117183'}}>
        <MDBContainer>
        {this.modal()}
            <MDBRow>
                <MDBCol xl={this.state.actionType==="VIEW"?"8":"12"} lg = {this.state.actionType==="VIEW"?"7":"12"} md="12" sm="12">
                    <div className="infoCard">
                        <Card className="editCard" style={{overflow: 'visible',outline:'none',marginBottom:'0px'}}>
                          
                            <CardHeader></CardHeader>
                            <div style={{flexDirection: this.props.isRTL?'row-reverse':'row',display: 'flex'}}>
                                <div className="topIcon" style={{background:'#117183'}}>
                                    <span className="material-icons" style={{color:'white',fontSize:23}}>group</span>
                                </div>
                                <div className="tableTitle" style={{display:this.props.isRTL?'inline-block':'inline-block',marginTop:this.props.isRTL?'-60px':'-60px',
                                marginLeft:this.props.isRTL?'0':'0rem',marginRight:this.props.isRTL?'0rem':'0'}}>
                                <p>{this.state.actionType ==="VIEW"?allStrings.userProfile:allStrings.edit}</p>
                                </div>
                            </div>
                            {this.state.type ==="OFFICE"&&this.state.actionType ==="VIEW"&&
                              <div style={{width:'100%',display:'inline-block'}}>
                                  <Rater style={{float:this.props.isRTL? 'left':'right',marginRight:'20px',marginLeft:'20px'}} rating={this.state.rate} total={5} interactive={false}/>
                              </div>
                            }
                            
                            <CardContent style={{minHeight:"390px",outline:'none'}}>
                            <MDBContainer>
                                <MDBRow>
                                    <MDBCol md="12">
                                    <form
                                    className="needs-validation"
                                    onSubmit={this.submitHandler}
                                    noValidate
                                    >
                                        <div className="grey-text">
                                        {this.state.actionType ==="VIEW"&&
                                        <MDBRow style={{flexDirection:this.props.isRTL?'row':'row-reverse'}}>
                                            <MDBCol md="6">
                                                <div className="md-form">
                                                <label htmlFor="form8" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.userType}</label>
                                                <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.user.type === "ADMIN"?allStrings.admin:this.state.user.type==="OFFICE"?allStrings.office:this.state.type==="SUB-ADMIN"?allStrings.subAdmin:allStrings.client} type="text" id="form8" className="form-control" validate/>
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                </div>
                                            </MDBCol>
                                            <MDBCol md="6">
                                                <div className="md-form">
                                                <label htmlFor="form8" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>#</label>
                                                <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.id} type="text" id="form8" className="form-control"  validate/>
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                </div>
                                            </MDBCol>
                                          
                                        </MDBRow>
                                        }
                                        {this.state.actionType ==="VIEW"&&this.state.type ==="USER"&&
                                        <MDBRow>
                                            <MDBCol md="6">
                                                <div className="md-form">
                                                <label htmlFor="form5" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.accountType}</label>
                                                <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.accountType==="ACTIVE"?allStrings.active:this.state.accountType==="BLOCKED"?allStrings.blocked:allStrings.notActive} type="text" id="form5" className="form-control" onChange={this.changeHandler} required validate/>
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                </div>
                                            </MDBCol>
                                            <MDBCol md="6">
                                                <div className="md-form">
                                                <label htmlFor="form52" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.contacts}</label>
                                                <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.myContacts} type="text" id="form52" className="form-control"  validate/>
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                </div>
                                            </MDBCol>
                                        </MDBRow>
                                        }{this.state.actionType ==="VIEW"&&this.state.type ==="USER"&&
                                        <MDBRow>
                                            <MDBCol md="6">
                                                <div className="md-form">
                                                <label htmlFor="form651" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.gifts}</label>
                                                <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.giftsCount} type="text" id="form651" name="gifts" className="form-control"  validate/>
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                </div>
                                            </MDBCol>
                                            <MDBCol md="6">
                                                <div className="md-form">
                                                <label htmlFor="form653" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.occasions}</label>
                                                <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.occasions} type="text" id="form652" name="occasions" className="form-control" validate/>
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                </div>
                                            </MDBCol>
                                        </MDBRow>
                                        }
                                        <MDBRow>
                                            <MDBCol md="6">
                                                <div className="md-form">
                                                <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.email}</label>
                                                <input disabled={this.state.actionType==="VIEW"?true:false} style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.email} type="email" id="form65" name="email" className="form-control" onChange={this.changeHandler} required validate/>
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                </div>
                                            </MDBCol>
                                            <MDBCol md="6">
                                                <div className="md-form">
                                                <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.name}</label>
                                                <input disabled={this.state.actionType==="VIEW"?true:false} style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.fullname} type="text" id="form645" name="fullname" className="form-control" onChange={this.changeHandler} required  validate/>
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                </div>
                                            </MDBCol>
                                        </MDBRow>
                                        <MDBRow>
                                            
                                            <MDBCol md="12">
                                                <div className="md-form">
                                                <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.username}</label>
                                                <input disabled={this.state.actionType==="VIEW"?true:false} style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.username} type="text" id="form645" name="username" className="form-control" onChange={this.changeHandler} required  validate/>
                                                <div class="valid-feedback">{allStrings.correct}</div>
                                                <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                </div>
                                            </MDBCol>
                                        </MDBRow>
                                        <MDBRow>
                                          <MDBCol md="6">
                                                <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.gender}</label>
                                                <TreeSelect virtual={false}
                                                    showSearch={false} 
                                                    style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                    treeCheckable = {false}    
                                                    value={this.state.gender}   
                                                    disabled={this.state.actionType==="VIEW"?true:false}  
                                                    treeNodeFilterProp="title"                      
                                                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                    placeholder={allStrings.gender}
                                                    onChange={(value) => {
                                                    console.log(value)
                                                    this.setState({gender:value});

                                                    }} 
                                                
                                                >
                                                    <TreeNode value="MALE" title={allStrings.male} key="MALE" />
                                                    <TreeNode value="FEMALE" title={allStrings.female} key="FEMALE" />
                                                    
                                                    
                                                </TreeSelect>
                                          </MDBCol>
                                          <MDBCol md="6">
                                            <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.birthday}</label>
                                            <DatePicker  style={{width:'100%'}} placeholder={allStrings.birthday} onChange={this.onChangeBirthday} disabled={this.state.actionType==="VIEW"?true:false} defaultValue={moment(this.state.birthday, 'YYYY-MM-DD')} />
                                          </MDBCol>
                                        </MDBRow>

                                        <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                          <MDBCol md="6">
                                              <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.country}</label>
                                              <TreeSelect virtual={false}
                                                  value={this.state.country}
                                                  disabled={this.state.actionType==="VIEW"?true:false}
                                                  showSearch={true} 
                                                  style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                  treeCheckable = {false}         
                                                  treeNodeFilterProp="title"                      
                                                  dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                  placeholder={allStrings.country}
                                                  onChange={(value) => {
                                                  console.log(value)
                                                  this.setState({country:value,phone:''});
                                                  this.getCountry(value)
                                                  }} 
                                              
                                              >
                                                  {this.state.countries.map(val=>(
                                                      <TreeNode value={val.id} title={this.props.isRTL?val.countryName_ar:val.countryName_en} key={val.id} />
                                                  ))}
                                              </TreeSelect>
                                          </MDBCol>
                                          <MDBCol md="6">
                                                <div className="md-form">
                                                <label htmlFor="form615" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.phone}</label>
                                                <input disabled={this.state.actionType==="VIEW"?true:false} onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/[^0-9+]/g,'') } style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.phone} type="text" id="form615" name="phone" className="form-control" onChange={this.changeHandler} validate/>
                                                </div>
                                            </MDBCol>
                                        </MDBRow>
                                        {this.state.lastDevice.length>0&&this.state.actionType==="VIEW"&&
                                          <MDBRow>
                                            <label htmlFor="form092" style={{textAlign:this.props.isRTL?'right':'left',width:'100%',marginTop:'20px',marginBottom:'20px'}}>{allStrings.lastLoginDevice}</label>
                                            <div className="table-responsive">
                                                <table className="table">
                                                <thead>
                                                    <tr style={{textAlign:'center'}}>
                                                        <th>{allStrings.appVersion}</th>
                                                        <th>{allStrings.deviceVersion}</th>
                                                        <th>{allStrings.deviceModel}</th>
                                                        <th scope="col">{allStrings.deviceType}</th>
                                                        
                                                    </tr>
                                                      
                                                </thead>
                                                <tbody>
                                                      <tr style={{textAlign:'center'}}>
                                                        <th>{this.state.lastDevice[0].appVersion}</th>
                                                        <th>{this.state.lastDevice[0].deviceVersion}</th>
                                                        <th>{this.state.lastDevice[0].deviceModel}</th>
                                                        <th scope="col">{this.state.lastDevice[0].deviceType}</th>
                                                      </tr>
                                                      
                                                </tbody>
                                                </table>
                                            </div>
                                          </MDBRow>
                                        }
                                        {this.state.accountType ==="BLOCKED"&&
                                        <MDBRow>
                                          <MDBCol md="12">
                                            <div className="md-form">
                                              <label htmlFor="form092" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.reason}</label>
                                              <input disabled value={this.state.blockReason}  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} type="text" id="form092" className="form-control"  name="blockReason"/>
                                            </div>
                                          </MDBCol>
                                        </MDBRow>
                                        }
                                        <MDBRow>
                                        <MDBCol md="6"></MDBCol>
                                      {
                                          this.state.type ==="SUB-ADMIN"?
                                          <MDBCol md="6">
                                            <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.permission}</label>
                                            <TreeSelect virtual={false}
                                                value={this.state.permission}
                                                showSearch={true} 
                                                disabled={this.state.actionType==="VIEW"?true:false}
                                                style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                treeCheckable = {false}         
                                                treeNodeFilterProp="title"                      
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                placeholder={allStrings.permission}
                                                onChange={(value) => {
                                                console.log(value)
                                                this.setState({permission:value});
                                                }} 
                                            
                                            >
                                                {this.state.permissions.map(val=>(
                                                    <TreeNode value={val.id} title={this.props.isRTL?val.permission_ar:val.permission_en} key={val.id} />
                                                ))}
                                            </TreeSelect>
                                            </MDBCol>
                                          :
                                          <MDBCol md="6"></MDBCol>
                                        }
                                          
                                        </MDBRow>
                                        {this.state.actionType==="EDIT"&&
                                        <MDBRow>
                                            <MDBCol md="12">
                                            <label htmlFor="form8930" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.profileImg}</label>

                                                <div className="fileUpload2"> 
                                                    <input  key={this.state.img} type='file' className="upImgs2" onChange={this.fileChangedHandler} ></input>
                                                    <span className="uploadParent"><UploadOutlined style={{color: '#000',fontSize: '14px',position: 'relative',top: '-3px',marginRight: '2px'}}/><span className="uploadName">{allStrings.upload}</span></span>
                                                </div>
                                                <div className="preview">
                                                {this.state.img&&
                                                <div style={{display:"inline-block",width: '100%',border: '1px solid mediumaquamarine'}}>
                                                    <img alt="" src={this.state.imgType==="data"?URL.createObjectURL(this.state.img):this.state.img} className="previewImg2"/>
                                                    
                                                    <span className="imgName">{this.state.imgName}</span>
                                                    <MDBIcon icon="trash" className="mr-2 removeImg3"
                                                    onClick={() => this.removeFile()}  ></MDBIcon>
                                                </div>
                                                }
                                                </div>
                                                
                                            </MDBCol>
                                        </MDBRow>
                                        }
                                        </div>
                                        {this.state.actionType ==="VIEW"&&this.state.type ==="USER"&&
                                        <div style={{textAlign: 'center',marginTop:'30px'}}>                                            
                                            <Tooltip title={allStrings.occasions} placement="top">
                                              <span onClick={()=>{this.props.history.push("occasions",{owner:this.state.id}) }}  
                                              className="material-icons" style={{color:'#117183',fontSize:50,cursor:'pointer'}}>event</span>
                                            </Tooltip>
                                            <Tooltip title={allStrings.gifts} placement="top">
                                              <span>
                                              <i class="fas fa-gifts" onClick={()=>{this.props.history.push("gifts",{owner:this.state.id}) }} style={{margin: '10px',top: '-13px',cursor:'pointer',position: 'relative',color:'#117183',fontSize:40}}></i>

                                              </span>
                                            </Tooltip>
                                        </div>
                                        }
                                        <br></br>
                                        <br></br>
                                        <div className="text-center">
                                        {this.state.actionType==="EDIT"&&
                                          <MDBBtn
                                          type="submit" style={{background:'#117183'}}
                                          rounded
                                          className="btn-block z-depth-1a"
                                          >
                                              <MDBIcon icon="edit" className="mr-2" />
                                              {allStrings.update}        
                                          </MDBBtn>
                                        }{this.state.actionType ==="VIEW"&&this.props.currentUser.user.type ==="ADMIN"&&
                                          <MDBBtn
                                            color="red"
                                            rounded
                                            style={{ borderRadius: "2px",background:'red' }}
                                            className="btn-block z-depth-1a"
                                            onClick={()=>{
                                                this.delete()
                                            }}
                                          >
                                            <MDBIcon icon="trash-alt" className="mr-2" />
                                            {allStrings.remove}
                                          </MDBBtn>
                                        }
                                          
                                      </div>
                                    </form>
                                    </MDBCol>
                                    
                                </MDBRow>
                            </MDBContainer>
                            </CardContent>
                        </Card>
                    </div>
                  </MDBCol>
                 {this.state.actionType ==="VIEW"&&this.imageSection()}    
            </MDBRow>
            {this.state.actionType ==="VIEW"&&this.state.id !==this.props.currentUser.user.id&&this.buttonsSection()}
            
            {this.state.type ==="USER"&&this.state.actionType ==="VIEW"&&
            this.contactsTable()
            }
            
        </MDBContainer>
      </Spin>
    </div> 
  )
  }
}



const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
});

const mapDispatchToProps = {
  setUser,
}


export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(UserInfo)
);
